<template>
    <div>
        <v-card class="line-container">
            <div class="line-img-container py-5">
                <img
                    width="350"
                    src="@/assets/line-logo-big.png">
            </div>
            <v-container>
                <v-row class="line-btn mb-3">
                    <v-btn
                        @click="submit()"
                        color="primary"
                        height="40">
                        {{ $vuetify.lang.t('$vuetify.lineService.upgradeLine')}}
                    </v-btn>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'LineService',

    methods: {
        async submit () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('line/update')
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.lineService.congratulation'),
                    text: this.$vuetify.lang.t('$vuetify.lineService.lineSeriveIsUpdated'),
                    type: 'success'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.line-container {
    margin-top: 2rem;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: 15px !important;
}
.line-btn, .line-img-container {
    display: flex;
    justify-content: center;
}
</style>
